module.exports = __webpack_public_path__ + "img/video-bg-xs.8c3236a8.jpg";